import Hosts from '../../../Hosts';


const object_type = 'calendar/event'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = () => `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/calendar_event'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        id: '',
        companycode: '',
        calendarId: '',
        title: '',
        category: '',
        dueDateClass: '',
        start: '',
        end: '',
        isAllDay: false,
        location: '',
        state: '',
        raw: '',
        isReadOnly: false
    }
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}